import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Quote } from '../../types/quote';
import { FreelancerSearchResult } from '../../types/search';
import { useAllianceStore } from '../../stores/allianceStore';
import { createUserAlliancesWithQuotes, getActiveAlliances } from '../../utils/allianceUtils';
import { useProfileStore } from '../../stores/profileStore';
import { mapUserAllianceToSearchResult } from '../../utils/freelancerUtils';
import QuoteFreelancerCard from './QuoteFreelancerCard';
import FreelancerProfileModal from '../freelancers/FreelancerProfileModal';

interface MyAlliancesProps {
  quote?: Quote;
}

const MyAlliances: React.FC<MyAlliancesProps> = ({ quote }) => {
  const { t } = useTranslation('quotes');

  const { alliances, fetchAlliances } = useAllianceStore();
  const { profile } = useProfileStore();

  const [selectedFreelancer, setSelectedFreelancer] = useState<FreelancerSearchResult | null>(null);

  useEffect(() => {
    if (alliances.length === 0) {
      fetchAlliances();
    }
  }, [alliances.length, fetchAlliances]);

  const userAlliances = getActiveAlliances(alliances, profile?.id || '');
  const userAlliancesWithQuotes = createUserAlliancesWithQuotes(
    userAlliances,
    quote?.alliances ?? []
  );
  return (
    <>
      <div className="space-y-4">
        <h3 className="text-xl font-bold text-secondary">
          {t('createQuoteModal.allianceSelectionTitle', 'Select Alliance Members')}
        </h3>
        <p>
          {t('AddAlliancesTexte', {
            ns: 'alliances',
            defaultValue: 'Ajouter des alliances a cette soumission',
          })}
        </p>
        <div className="flex flex-col gap-2 mt-4">
          {userAlliancesWithQuotes.length === 0 ? (
            <div className="text-gray-500 py-4 text-center">
              {t('alliances.noneActive', {
                ns: 'common',
                defaultValue: 'Aucune alliance active',
              })}
            </div>
          ) : (
            userAlliancesWithQuotes.map((userAllianceWithQuote, id) => {
              const isLast = id === userAlliancesWithQuotes.length - 1;
              const { userAlliance, quoteAlliance } = userAllianceWithQuote;

              return (
                <QuoteFreelancerCard
                  editMode={true}
                  key={userAlliance.alliance_id}
                  freelancer={userAlliance.user}
                  className={`px-0 md:px-0 ${isLast ? '' : 'border-b border-[#E0E0E0]'}`}
                  onClick={() => {
                    setSelectedFreelancer(mapUserAllianceToSearchResult(userAlliance));
                  }}
                  quote={quote}
                  userAlliance={userAlliance}
                  quoteAlliance={quoteAlliance}
                />
              );
            })
          )}
        </div>
      </div>

      {selectedFreelancer && (
        <FreelancerProfileModal
          freelancer={selectedFreelancer}
          onClose={() => setSelectedFreelancer(null)}
        />
      )}
    </>
  );
};

export default MyAlliances;
